import Form from "components/pages/healthCare/form";
import Result from "components/pages/healthCare/result";
import {IPageRoutes} from "routes";

const pageRoutes: IPageRoutes = {
  default: {
    type: "form",
    component: Form,
  },
  form: {
    type: "form",
    component: Form,
  },
  result: {
    component: Result,
    type: "result",
  },
};
export default pageRoutes;
